import React from 'react'
import { Hero } from '../../components/compounds/hero'

export const HomeHero: React.FC<React.ComponentProps<typeof Hero>> = (
  props,
) => <Hero {...props} />
